// extracted by mini-css-extract-plugin
export default {"container":"container-3wgC6","favoriteTracksButton":"favoriteTracksButton-2MNAN"};